import React, {Component} from 'react'
import ModelEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class ModelEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            model: {},
            modelName: '',
            modelForm: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        const modelId = this.props.match.params.modelId
        AppContext.getApiClient().get('/guided-selling-models/' + modelId).then((model) => {
            const modelForm = <ModelEditForm model={model} />
            this.setState({
                modelName: model.attributes.name,
                modelForm: modelForm
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.modelForm}
            </div>
        );
    }
}

export default ModelEdit


// WEBPACK FOOTER //
// ./src/guided-selling/edit.component.jsx